import {Injectable} from '@angular/core';
import {BaseObservableService} from './base-obeservable-service';
import {DonationProgramPayout} from '../_models/donation-program-payout';

@Injectable({
    providedIn: 'root'
})
export class DonationProgramPayoutService extends BaseObservableService<DonationProgramPayout> {
    destination = 'donation-program-payouts';
}
